import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, ThemeProvider, LanguageProvider } from '@shondalai/ui-commons';
import FormSubmission from '@/pages/FormSubmission';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function PublicApp() {
  console.log('EasyForms: PublicApp component rendering');

  const joomlaOptions = (window as any).Joomla?.getOptions?.('com_easyforms') || {};
  console.log('EasyForms: Joomla options:', joomlaOptions);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="easyforms-theme">
        <LanguageProvider>
          <AuthProvider componentNamespace="com_easyforms" userDataKey="user">
            <FormSubmission />
            <Toaster position="top-right" />
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default PublicApp;

